import { render, staticRenderFns } from "./UsuariosclientebinariosAutomodal.vue?vue&type=template&id=3d48de80&"
import script from "./UsuariosclientebinariosAutomodal.vue?vue&type=script&lang=js&"
export * from "./UsuariosclientebinariosAutomodal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports